// extracted by mini-css-extract-plugin
module.exports = {"submittedPurchaseOrders":"SubmittedPOsList_submittedPurchaseOrders__tmzVT","submittedPurchaseOrders_withPOSore":"SubmittedPOsList_submittedPurchaseOrders_withPOSore__joosj"};